export default {
      id: "times-circle-usage",
      viewBox: "0 0 46 46",
      url: __webpack_public_path__ + "img/icons.svg#times-circle",
      toString: function () {
        return this.url;
      }
    }